// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-ed558de2] {\n  width: 33px;\n  display: block;\n}\n.header[data-v-ed558de2] {\n  background-color: #44484c;\n  border-bottom: 1px solid #36393d;\n}\n.navbar[data-v-ed558de2] {\n  padding: 0;\n}\n.navbar .navbar-brand[data-v-ed558de2] {\n    background-color: #53575b;\n}\n.navbar .navbar-nav[data-v-ed558de2] {\n    height: 65px;\n}\n[data-v-ed558de2] .dropdown-toggle::after {\n  display: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
